export const CDN_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
export const SWIGGY_API_URL = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=13.0417637&lng=80.200757&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";
export const MENU_API_URL =
  "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=13.022390076021098&lng=80.16489744186401&restaurantId=";
export const IMG_ITEMS_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/";
export const Linkedin_Link = "https://www.linkedin.com/in/vigneshwarancj1";
export const X_Link = "https://x.com/vigneshwarancj";
export const Github_Link = "https://github.com/vigneshcj001";
export const Instagram_Link = "https://www.instagram.com/vigneshwarancj1";
export const Email_Link = "mailto:vigneshwarancj@gmail.com";

export const GITHUB_API = "https://api.github.com/users/vigneshcj001";



export const Template_ID  = "template_rx2rkfc";
export const public_key = "9n9kmaTzgc1qIhDCW";
export const service_id = "service_myiqt9k";

export const Google_SVG = "https://www.svgrepo.com/show/355037/google.svg";
export const Github_SVG = "https://www.svgrepo.com/show/503359/github.svg";